export const ROLE = {
  IS_AUTHENTICATED_ANONYMOUSLY: 'IS_AUTHENTICATED_ANONYMOUSLY',
  IS_AUTHENTICATED_ONLY: 'IS_AUTHENTICATED_ONLY',
  IS_MANAGER: 'IS_MANAGER',
};

export default [
  { path: /\/login/, role: ROLE.IS_AUTHENTICATED_ANONYMOUSLY },
  { path: /\/closed-account/, role: ROLE.IS_AUTHENTICATED_ANONYMOUSLY },
  { path: /\/restore/, role: ROLE.IS_AUTHENTICATED_ANONYMOUSLY },
  { path: /\/np/, role: ROLE.IS_AUTHENTICATED_ANONYMOUSLY },
  { path: /\/ne/, role: ROLE.IS_AUTHENTICATED_ANONYMOUSLY },
  { path: /\/confirm/, role: ROLE.IS_AUTHENTICATED_ANONYMOUSLY },
  { path: /\/manage/, role: ROLE.IS_MANAGER },
  { path: /\/reports-applications/, role: ROLE.IS_AUTHENTICATED_ONLY },
  { path: /\/reports-commissions/, role: ROLE.IS_AUTHENTICATED_ONLY },
  { path: /\/reports-applications-export/, role: ROLE.IS_AUTHENTICATED_ONLY },
  { path: /\/reports-commissions-export/, role: ROLE.IS_AUTHENTICATED_ONLY },
  { path: /\//, role: ROLE.IS_AUTHENTICATED_ONLY },
];
